import React from 'react';
import './sentenceMap.css';
const families = [['subject', 'SUBJECT'], ['auxiliary', 'MODAL / AUXILIARY'], ['verb', 'VERB'], ['link', 'LINK / RELATIVE WORD'], ['detail', 'OBJECT / COMPLEMENT / DETAIL / CLAUSE'], ['punctuation', 'PUNCTUATION']];
export default function SentenceRoleLegend() {
    return <details className="btl-role-legend"><summary>Grammar-role colour key</summary>
        <ul>{families.map(([role, label]) => <li key={role} className="btl-sentence-token" data-role={role}>{label}</li>)}</ul>
        <p>Block colours show grammar roles. ✓ GRAMMATICAL and ✕ ERROR describe the sentence; yellow notes explain context or stylistic preference.</p>
    </details>;
}
